import styled from 'styled-components'

const StyledCourseGroup = styled.div`
  .heading {
    user-select: none;
    font-weight: 600;
    font-size: 15px;
    padding: 20px;
    border-radius: 50rem;
    text-align: center;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ theme }) => theme.color.gray[300]};

    .count {
      display: flex;
      margin-left: 10px;
      text-align: center;
      font-size: 13px;
      height: 24px;
      min-width: 24px;
      border-radius: 50rem;
      padding: 0 4px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${({ theme }) => theme.color.gray[600]};
      background-color: ${({ theme }) => theme.color.gray[200]}c4;
    }
  }

  &:not(:first-child) {
    margin-top: 40px;
  }
`

export default StyledCourseGroup
